import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import { useRootStore } from 'core/hooks/use-root-store';
import { CandidateLoginStore } from './candidate-login.store';

const CandidateLoginContext = React.createContext<CandidateLoginStore | null>(null);

export const CandidateLoginProvider = ({ children }: { children: ReactNode }) => {
   const rootStore = useRootStore();
   const { i18n, t } = useTranslation('global');

   const selectedLanguage = Cookies.get('selectedLanguage') || i18n.language || 'ukr';
   const apiLanguage = selectedLanguage === 'ukr' ? 'uk' : selectedLanguage;

   const [store] = React.useState<CandidateLoginStore>(
      () => new CandidateLoginStore(rootStore, t, apiLanguage)
   );

   return <CandidateLoginContext.Provider value={store}>{children}</CandidateLoginContext.Provider>;
};

export const useCandidateLogin = (): CandidateLoginStore => {
   const ctx = React.useContext(CandidateLoginContext);
   if (!ctx) {
      throw new Error('useCandidateLogin must be used inside CandidateLoginProvider');
   }
   return ctx;
};
